import facebook from "../../../assets/ic24-fb.png";
import telegram from "../../../assets/ic24-tg.png";
import viber from "../../../assets/ic24-vb.png";
import instagram from "../../../assets/ic24-ig.png";
import youTube from "../../../assets/ic24-yt.png";
import tikTok from "../../../assets/ic24-tt.png";
import { useAppSelector } from "../../../hooks/redux-hooks";
import { selectMainState } from "../../../store/slices/main";
import { SocialLinks } from "../../../common/enums";

const FooterLinks = () => {
  const { SEOSettingsDefault } = useAppSelector(selectMainState);

  const handleClick = (link: string) => {
    window.open(link, "_blank");
  };
  return (
    <div className="md:min-w-[21.5rem]">
      <h4 className=" text-sm font-semibold whitespace-nowrap">
        Радіо «Сільпо» у соцмережах
      </h4>
      <div className="w-full flex flex-wrap justify-start items-center">
        {SEOSettingsDefault?.socialLinks.map((socialLink) => {
          let imagePath = "";

          switch (socialLink.name) {
            case SocialLinks.telegram:
              imagePath = telegram;
              break;
            case SocialLinks.viber:
              imagePath = viber;
              break;
            case SocialLinks.facebook:
              imagePath = facebook;
              break;
            case SocialLinks.instagram:
              imagePath = instagram;
              break;
            case SocialLinks.youTube:
              imagePath = youTube;
              break;
            case SocialLinks.tikTok:
              imagePath = tikTok;
              break;
          }
          return (
            <>
              {!!socialLink.link && (
                <div
                  className={`pt-4 pr-4 ${!imagePath && "hidden"}`}
                  key={socialLink.id}
                >
                  <img
                    className="w-8 h-8 cursor-pointer"
                    src={imagePath}
                    alt={socialLink.name}
                    onClick={() => {
                      handleClick(socialLink.link);
                    }}
                  />
                </div>
              )}
            </>
          );
        })}
      </div>
    </div>
  );
};

export default FooterLinks;
